import app from '../app.first';
import $ from 'jquery';
import Cookies from 'js-cookie';

app.IfactForm = class extends app.Component {
	//this functIion runs on every single page, so call functions from this function that you need to run on every page
	constructor($this) {
		super($this);
		this.onLoad();
		$(() => this.onDocumentReady($this));
	}

	onLoad() {

	}

	onDocumentReady($this) {
		// DATE PICKER
		// only add  if we have a date picker. @todo put  into the main JS function? should be generic throughout the project?
		if ($(".pika-day").length) {
			setDatePickers();
		}

		function setDatePickers() {
			var picker = [];
			$('.pika-day').each(function (index, element) {

				var field_type = $(this).data("field-type");
				let show_time = false;
				let date_format = 'YYYY-MM-DD';
				if (field_type == 'datetime') {
					show_time = true;
					date_format = 'YYYY-MM-DD HH:mm:ss';
				}

				picker[index] = new Pikaday({
					field: element,
					format: date_format,
					use24hour: false,
					showTime: show_time
				});
			});
		}

		if ($('.otp-form').length) {
			setInterval(function () {
				let checked = $('.otp-form').find('input[type="checkbox"]').is(':checked');
				$('.otp-form').find('#otp-submit-button').prop('disabled', !checked);
			}
				, 600);
		}


	}

}
